import setupAccordions from './accordions'
import setupSwipers from './swipers'
import setupMenu from './menu'
import setupModals from './modals'
import setupVideos from './videos'
import setupNavigation from './navigation'
import setupForm from './form'
import setupFooter from './footer'
import setupParallax from './parallax'

/*
    IMPORTANT INFORMATION

    There is no need for listening to the DOMContentLoaded event, scripts are/should be deferred until the document is loaded.

    Please don't fill up this file with lots of different functionality. Rather, split them up into their own modules.
*/
setupParallax()
setupForm()
setupFooter()
setupMenu()
setupAccordions()
setupSwipers()
setupModals()
setupVideos()
setupNavigation()